// extracted by mini-css-extract-plugin
export default {"searchContainer":"MySearchList_searchContainer__GTaSv"};